var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",class:_vm.spaceBetween && 'justify-content-between',style:([{ alignItems: _vm.align, justifyContent: _vm.justify_content, flexDirection: _vm.flex_direction }, this.styles]),on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }